/**
 * Premium Index 代理服务 API（GET /api/premium-index/history）
 */

import { API_CONFIG } from '@/config/api';
import { apiFetch } from '@/lib/apiFetch';

const BASE = API_CONFIG.PREMIUM_INDEX_PATH_PREFIX;

export interface PremiumCandle {
  ts_ms: number;
  open: number;
  high: number;
  low: number;
  close: number;
}

export interface PremiumHistoryResponse {
  exchange: string;
  symbol: string;
  interval: string;
  count: number;
  data: PremiumCandle[];
}

export type PremiumExchange = 'bybit' | 'okx' | 'binance' | 'gateio';

export interface PremiumHistoryParams {
  exchange: PremiumExchange;
  symbol: string;
  hours?: number;
  interval?: string;
  start_ts?: number;
  end_ts?: number;
  limit?: number;
}

export async function getPremiumHistory(params: PremiumHistoryParams): Promise<PremiumHistoryResponse> {
  const q = new URLSearchParams();
  q.set('exchange', params.exchange);
  q.set('symbol', params.symbol.trim());
  if (params.hours != null) q.set('hours', String(params.hours));
  if (params.interval != null) q.set('interval', params.interval);
  if (params.start_ts != null) q.set('start_ts', String(params.start_ts));
  if (params.end_ts != null) q.set('end_ts', String(params.end_ts));
  if (params.limit != null) q.set('limit', String(params.limit));

  const res = await apiFetch(`${BASE}/history?${q.toString()}`, { method: 'GET' });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || `HTTP ${res.status}`);
  }
  return res.json() as Promise<PremiumHistoryResponse>;
}
